import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=3b572349&scoped=true&"
import script from "./OnboardingHeader.vue?vue&type=script&lang=ts&"
export * from "./OnboardingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingHeader.vue?vue&type=style&index=0&id=3b572349&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b572349",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
